export const allItemsTriggerAction = () => ({
    type: 'FETCH_ALL_ITEMS'
})